import { Clock } from 'lucide-react'

export const IssuesEmptyState = () => {
  return (
    <div className="text-center py-8">
      <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
        <Clock className="w-8 h-8 text-gray-400" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        No Open Issues
      </h3>
      <p className="text-gray-400 text-sm max-w-sm mx-auto">
        When you report new issues, they'll appear here.
      </p>
    </div>
  )
}
